import { CommentThreadFragment } from "generated-graphql/graphql";

export function isCommentDeletableByUser(
  comment: Pick<CommentThreadFragment, "isSystemMessage" | "isProtected"> & {
    user?: { id: string } | null;
  },
  currentUserId: string | undefined
): boolean {
  return Boolean(
    currentUserId &&
    comment.user?.id === currentUserId &&
    !comment.isSystemMessage &&
    !comment.isProtected
  );
}

export function getCommentAuthor(
  comment: Pick<CommentThreadFragment, "updatedBy"> & {
    user?: { email?: string | null } | null;
  }
): string {
  return comment.user?.email ?? comment.updatedBy ?? "Someone";
}
